export const WarningTriangle = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby="warningTriangleTitle"
    >
      <title id="warningTriangleTitle">Warning triangle</title>
      <path
        d="M5.88091 2.36819L1.04783 10.4083C0.554669 11.2284 1.17571 12.2499 2.16692 12.2499H11.8331C12.8243 12.2499 13.4453 11.2284 12.9522 10.4083L8.11909 2.36819C7.62348 1.54394 6.37651 1.54394 5.88091 2.36819Z"
        stroke="#AC1201"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M7 7.4375V5.6875" stroke="#AC1201" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M7 10.5C7.48325 10.5 7.875 10.1082 7.875 9.625C7.875 9.14175 7.48325 8.75 7 8.75C6.51675 8.75 6.125 9.14175 6.125 9.625C6.125 10.1082 6.51675 10.5 7 10.5Z"
        fill="#AC1201"
      />
    </svg>
  )
}
